import browserHistory from 'react-router/lib/browserHistory'
import {canonicalRedirect} from '../../../shared/utils'
import {
  canonicalizeCategory,
  canonicalizeProduct,
  canonicalizeStore
} from '../../../shared/canonicalize'
import {
  fetchCategoryById,
  fetchProductForStore,
  fetchSubchannels,
  fetchStore
} from '../actions/api'
import {productDesigns} from '../actions/index'

const isNumber = (num) => !isNaN(Number(num))

const fetchFinalStore = async (dispatch, id) => {
  let result = await dispatch(fetchStore(id))

  // Yes They literally have PrimaryStoreID of -1 in the DB
  // TODO(wes): Fix DB values
  const {body: [store = {}] = []} = result
  if (store.PrimaryStoreID > 0) {
    return dispatch(fetchStore(result.body[0].PrimaryStoreID))
  }

  return Promise.resolve(result)
}

const redirect = (props, canonical) => {
  const current = (browserHistory || props.router).createHref(props.location)

  return canonicalRedirect(canonical, current, props.replace)
}

const findCategory = (parent, id) => {
  if (parent.ID === id) {
    return parent
  }

  return (parent.Categories || [])
    .map((c) => findCategory(c, id))
    .filter((c) => c)[0]
}

export const fetchAndValidateStore = (props) => {
  const {
    dispatch,
    location: {query},
    statusCode,
    canonicalize = true
  } = props
  const storeId = query.schoolid || query.storeid

  if (!isNumber(storeId)) {
    return statusCode(404)
  }

  return fetchFinalStore(dispatch, storeId).then((result) => {
    if (!result.body) {
      return statusCode(404)
    }

    let redirectStatus = true
    if (canonicalize) {
      redirectStatus = redirect(
        props,
        canonicalizeStore(result.body[0], [], query)
      )
    }

    return canonicalize ? !redirectStatus || result : result.body
  })
}

export const fetchAndValidateCategory = async (props) => {
  const {
    dispatch,
    location: {query},
    statusCode
  } = props

  if (!(isNumber(query.schoolid) && isNumber(query.category))) {
    return statusCode(404)
  }

  const [{body: [store] = []}, {body: category}] = await Promise.all([
    fetchFinalStore(dispatch, query.schoolid),
    dispatch(fetchCategoryById(query.schoolid, query.category))
  ])

  if (!store) {
    return statusCode(404)
  }

  if (store && !category) {
    delete query.category
    return !redirect(props, canonicalizeStore(store, [], query))
  }

  const target = findCategory(category, parseInt(query.category, 10))

  return !redirect(
    props,
    canonicalizeCategory(store, target.RedirectCategoryID || target.ID, query)
  )
}

export const fetchAndValidateProduct = (props) => {
  const {
    dispatch,
    location: {query},
    statusCode
  } = props
  const {schoolid, productid} = query

  if (!(isNumber(schoolid) && isNumber(productid))) {
    return statusCode(404)
  }

  return Promise.all([
    fetchFinalStore(dispatch, schoolid),
    dispatch(fetchProductForStore(schoolid, productid)),
    dispatch(productDesigns.get({query: {schoolid, productid}}))
  ]).then((result) => {
    const [{body: [store] = []}, {body: product}, {body: designs}] = result

    if (!store || !product || !designs) {
      return statusCode(404)
    }

    if (designs.success === false && designs.redirectUrl) {
      props.replace(designs.redirectUrl, 302)
      return false
    }

    return (
      !redirect(props, canonicalizeProduct(store, product, query)) || result
    )
  })
}

export const fetchAndValidateChannel = (props) => {
  const channelRegExp = /\/(\w+)_directory/
  const {dispatch, location, params, statusCode} = props

  const channel = location.pathname.match(channelRegExp)[1]
  let path = `${params.country || params.sport}/${params.state || params.team}${
    params.city ? `/${params.city}` : params.league ? `/${params.league}` : ''
  }`
  path = path.replace(/\.aspx$/gi, '')

  return dispatch(fetchSubchannels(channel, path)).then((result) => {
    if (!result.body) {
      return statusCode(404)
    }

    return result
  })
}
